/*
 * Copyright (c) Worldline 2023.
 */

export const Routes = {
    // constants for replacements
    params: {
        sessionId: ':sessionId',
        signerId: ':signerId',
        reason: ':reason',
        locale: ':locale',
        noParam: 'noParam',
        shortId: ':shortId',
        pId: ':pId'
    },
    evidences: ':sessionId/evidences/:locale',
    agreements: ':sessionId/agreements/:locale',
    pendingSignature: ':sessionId/pendingSignature/:locale',
    signatures: ':sessionId/signatures/:locale',
    resume: ':sessionId/resume/:locale',
    session: 'session/:sessionId/:locale',
    page404: '404/:locale',
    unexpectedError: 'error/:locale',
    unexpectedErrorWithoutLocale: 'error',
    confirmCancellation: ':sessionId/confirmCancellation/:locale',
    canceled: 'canceled/:locale',
    hold: 'hold/:locale',
    error: ':sessionId/error/:reason/:locale',
    help: ':sessionId/help/:locale',
    contact: ':sessionId/contact/:locale',
    legalNotices: ':sessionId/legalNotices/:locale',
    redirection: ':sessionId/redirect/:locale',
    tokenRenewal: 'tokenRenewal/:locale/trd/:trd',
    smartphoneagreements: 'smartphone/shortId/:shortId/:locale',
    customization: 'customization',

    pIdSuffix: '/pId/:pId'
}
